var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"choose"},_vm._l((_vm.shapes),function(item,index){return _c('span',{staticClass:"c iconfont",style:(index === _vm.selected ? 'border: 1px solid #31AAFF;' : ''),domProps:{"innerHTML":_vm._s(item)},on:{"click":function($event){_vm.selectOne(index)}}})}))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59bf619b","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chooseShape.vue
// module id = null
// module chunks = 